// Centralized data for Diamond Life Bursa Masaj Salonu
export const SITE = {
  name: "Diamond Life Bursa Masaj Salonu",
  short: "Diamond Life",
  tagline: "Bursa Masaj Salonu — Premium Spa Deneyimi",
  description:
    "Bursa Masaj Salonu — Diamond Life Nilüfer Bursa premium spa merkezi. Sertifikalı terapistler, organik yağlar ve butik atmosferde klasik, aromaterapi, medikal, Bali, çift ve sıcak taş masajı.",
  seoTitleSuffix: "Bursa Masaj Salonu | Diamond Life",
  agency: {
    name: "Bana Bi Media",
    location: "İstanbul",
    phoneRaw: "+905324751871",
    whatsappRaw: "905324751871",
    phoneDisplay: "+90 532 475 18 71",
  },
  phoneDisplay: "+90 533 253 73 76",
  phoneRaw: "+905332537376",
  whatsappRaw: "905332537376",
  email: "info@diamondlifebursa.com",
  address: "Şükran Apt. Yurtiçi Kargo Üstü, Fethiye, Sanayi Cd. Kat:5 D:4, Nilüfer/Bursa",
  addressFull: "Şükran Apartmanı Yurtiçi Kargo Üstü, Fethiye, Sanayi Cd. Kat:5 Daire:4, 16110 Nilüfer/Bursa",
  mapsShare: "https://share.google/XEFi2hDHYp4Meev0K",
  mapsQuery: "Diamond Life Masaj Salonu Nilüfer Bursa",
  mapsEmbed: "https://www.google.com/maps?q=Diamond+Life+Masaj+Salonu+Nil%C3%BCfer+Bursa&output=embed&z=16",
  mapsDirections: "https://www.google.com/maps/dir/?api=1&destination=Diamond+Life+Masaj+Salonu+Nil%C3%BCfer+Bursa",
  hours: [
    { label: "Pazartesi - Cumartesi", value: "10:00 — 23:00" },
    { label: "Pazar", value: "12:00 — 22:00" },
  ],
  socials: {
    instagram: "https://www.instagram.com/masajsalonu_bursa/",
  },
  baseUrl: "https://diamondmasajnilufer.com",
  logoUrl: "/diamondlife-logo.png",
};

export const SERVICES = [
  {
    slug: "klasik-masaj",
    title: "Klasik Masaj",
    short: "İsveç tekniği ile tüm vücut için rahatlatıcı premium ritüel.",
    duration: "60 - 90 dk",
    image: "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?auto=format&fit=crop&w=1200&q=80",
    cover: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?auto=format&fit=crop&w=1900&q=80",
    benefits: ["Kas gerginliğini azaltır", "Dolaşımı iyileştirir", "Stres seviyesini düşürür", "Genel rahatlama sağlar"],
    description:
      "Klasik İsveç masajı; uzun, akıcı vuruşlar, ovma ve dairesel hareketlerle yüzeysel kas tabakalarını hedefleyen butik premium tekniktir. Organik aromatik yağlarımız cilde ipeksi bir his bırakırken kasların derin gevşemesine zemin hazırlar.",
  },
  {
    slug: "aromaterapi-masaji",
    title: "Aromaterapi Masajı",
    short: "Doğal esansiyel yağlarla zihinsel ve fiziksel terapi.",
    duration: "60 - 90 dk",
    image: "https://images.unsplash.com/photo-1741522509438-a120c0bb5e88?auto=format&fit=crop&w=1200&q=80",
    cover: "https://images.unsplash.com/photo-1600334129128-685c5582fd35?auto=format&fit=crop&w=1900&q=80",
    benefits: ["Zihni sakinleştirir", "Uyku kalitesini artırır", "Hormonal dengeyi destekler", "Cildi besler"],
    description:
      "Lavanta, okaliptüs, gül ve sandal ağacı gibi seçkin esansiyel yağların terapötik etkisi, hafif baskılı masaj teknikleriyle birleşir. Aromaterapi; ruh hâlini iyileştirir, sinir sistemini dengeler ve duyusal bir yolculuk sunar.",
  },
  {
    slug: "medikal-masaj",
    title: "Medikal Masaj",
    short: "Kronik ağrılara yönelik terapötik fizyoterapi tekniği.",
    duration: "45 - 60 dk",
    image: "https://images.pexels.com/photos/6628701/pexels-photo-6628701.jpeg?auto=compress&w=1200&q=80",
    cover: "https://images.unsplash.com/photo-1591343395082-e120087004b4?auto=format&fit=crop&w=1900&q=80",
    benefits: ["Bel ve sırt ağrısını hafifletir", "Postür düzelir", "Hareket esnekliği artar", "İyileşmeyi hızlandırır"],
    description:
      "Bel, boyun, sırt ağrıları ve postür bozuklukları için fizyoterapi tekniklerini birleştiren hedefli bir masajdır. Yavaş ve kontrollü basınçla yapılan teknik, sporcular ve uzun süre masa başında çalışanlar için idealdir.",
  },
  {
    slug: "bali-masaji",
    title: "Bali Masajı",
    short: "Uzak Doğu egzotik şifa ritüeli, akupresur + esneme + aroma.",
    duration: "75 - 90 dk",
    image: "https://images.unsplash.com/photo-1745327883508-b6cd32e5dde5?auto=format&fit=crop&w=1200&q=80",
    cover: "https://images.unsplash.com/photo-1540555700478-4be289fbecef?auto=format&fit=crop&w=1900&q=80",
    benefits: ["Tüm vücut esnekliği", "Enerji akışı dengelenir", "Egzotik aromatik deneyim", "Derin gevşeme"],
    description:
      "Akupresur, hafif esnetme hareketleri ve aromaterapi tekniklerini birleştiren geleneksel Endonezya masajıdır. Otantik atmosferinde Uzak Doğu'nun şifa ritüelini Bursa'da yaşayabilirsiniz.",
  },
  {
    slug: "cift-masaji",
    title: "Çift Masajı",
    short: "İki kişilik özel suitte paylaşılan lüks ritüel.",
    duration: "60 - 90 dk",
    image: "https://images.unsplash.com/photo-1639162906614-0603b0ae95fd?auto=format&fit=crop&w=1200&q=80",
    cover: "https://images.unsplash.com/photo-1600334129128-685c5582fd35?auto=format&fit=crop&w=1900&q=80",
    benefits: ["Birlikte rahatlama", "Romantik atmosfer", "Özel oda ve karşılama", "Şampanya servisi"],
    description:
      "Çift masajı, iki kişilik özel suitimizde, iki ayrı terapist eşliğinde eş zamanlı uygulanır. Kutlamalar, yıldönümleri veya birlikte bir nefes almak isteyen çiftler için tasarlanmış imzalı bir ritüeldir.",
  },
  {
    slug: "sicak-tas-masaji",
    title: "Sıcak Taş Masajı",
    short: "Volkanik bazalt taşlarla derin ısı terapisi.",
    duration: "60 - 90 dk",
    image: "https://images.unsplash.com/photo-1610402601271-5b4bd5b3eba4?auto=format&fit=crop&w=1200&q=80",
    cover: "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?auto=format&fit=crop&w=1900&q=80",
    benefits: ["Kasları derinden gevşetir", "Kan dolaşımı hızlanır", "Toksin atımını destekler", "Eklem sertliği azalır"],
    description:
      "Isıtılmış volkanik bazalt taşlarının vücudun enerji noktalarına yerleştirilmesiyle uygulanan bu teknik, kasların derinlemesine gevşemesini sağlar. Sıcaklık, dokulara nüfuz ederek meditatif bir denge yaratır.",
  },
];

export const WHY_US = [
  { title: "Sertifikalı Uzman Kadro", desc: "Uluslararası akredite sertifikalara sahip, 5+ yıl deneyimli terapistler.", icon: "Award" },
  { title: "Hijyen Garantisi", desc: "Her seans için tek kullanımlık örtü, dezenfekte yatak, hijyenik havlu seti.", icon: "ShieldCheck" },
  { title: "Organik Premium Ürünler", desc: "%100 saf, Avrupa menşeili, organik sertifikalı esansiyel yağlar.", icon: "Droplets" },
  { title: "Kişiselleştirilmiş Hizmet", desc: "Her misafire özel ön görüşme, sağlık anamnez ve ihtiyaca yönelik terapi planı.", icon: "Heart" },
  { title: "Butik Premium Atmosfer", desc: "Sessiz, ferah, dinlendirici tasarım. 5 duyuya hitap eden butik konsept.", icon: "Sparkles" },
  { title: "%95 Tekrar Ziyaret", desc: "186+ olumlu Google yorumu, 4.9/5 ortalama puan. Misafirlerin %95'i tekrar geliyor.", icon: "Star" },
];

export const EXPERIENCE = [
  { step: "01", title: "Hoş Geldiniz & Ön Görüşme", desc: "Resepsiyonda karşılanırsınız. Sağlık anamnez formu doldurur, ihtiyaçlarınızı konuşuruz." },
  { step: "02", title: "Hazırlık · Aroma & Ortam", desc: "Özel odanıza alınırsınız. Yağ seçiminizi yaparken havlular, müzik ve ışıklandırma hazırlanır." },
  { step: "03", title: "Profesyonel Masaj Seansı", desc: "Sertifikalı terapistiniz seçtiğiniz teknikle 45-90 dakika boyunca size özel uygular." },
  { step: "04", title: "Dinlenme & Bakım Önerileri", desc: "Bitki çayı ikramıyla 15 dakika dinlenirsiniz. Size özel ev bakım önerileri verilir." },
];

export const PRICE_NOTE = "Tüm masajlarımızda kese köpük bizden hediye";

export const PRICING = {
  default: [{ duration: "60 dk", label: "Tüm masaj çeşitlerinde", price: "2.400 TL", num: 2400 }],
  "klasik-masaj": [
    { duration: "40 dk", label: "Klasik Yağlı Masaj", price: "1.800 TL", num: 1800 },
    { duration: "60 dk", label: "Tüm masaj çeşitlerinde", price: "2.400 TL", num: 2400 },
  ],
  "medikal-masaj": [
    { duration: "40 dk", label: "Soft Medikal Mix Masaj", price: "2.000 TL", num: 2000 },
    { duration: "60 dk", label: "Tüm masaj çeşitlerinde", price: "2.400 TL", num: 2400 },
  ],
};

export const getPrices = (slug) => PRICING[slug] || PRICING.default;

export const CAMPAIGNS = [
  {
    badge: "01",
    duration: "40 Dakika",
    title: "Klasik Yağlı Masaj",
    price: "1.800",
    note: "Tüm masajlarımızda kese köpük bizden hediye.",
    cta: "Hemen Rezervasyon",
  },
  {
    badge: "02",
    duration: "40 Dakika",
    title: "Soft Medikal Mix Masaj",
    price: "2.000",
    note: "Tüm masajlarımızda kese köpük bizden hediye.",
    cta: "Hemen Rezervasyon",
  },
  {
    badge: "03",
    duration: "60 Dakika",
    title: "Tüm Masaj Çeşitlerimizde",
    price: "2.400",
    note: "Tüm masajlarımızda kese köpük bizden hediye.",
    cta: "Hemen Rezervasyon",
  },
];

export const STATS = [
  { value: "8000+", label: "Mutlu Misafir" },
  { value: "4.9/5", label: "Google Puanı" },
  { value: "12000+", label: "Tamamlanan Seans" },
  { value: "18+", label: "Sertifika" },
  { value: "12+", label: "Yıl Tecrübe" },
  { value: "95%", label: "Tekrar Ziyaret" },
  { value: "06", label: "Masaj Türü" },
  { value: "186+", label: "Google Yorumu" },
];

export const TESTIMONIALS = [
  { name: "Elif K.", rating: 5, text: "Bursa'da bu seviyede bir spa deneyimi yaşamayı beklemiyordum. Atmosfer, terapist ve ritüel akışı beş yıldızlı otel kalitesinde.", when: "1 hafta önce", service: "Aromaterapi Masajı" },
  { name: "Murat A.", rating: 5, text: "Medikal masaj sayesinde aylardır süregelen sırt ağrım büyük ölçüde geçti. Salon hijyeni ve özel oda konsepti bir başka.", when: "2 hafta önce", service: "Medikal Masaj" },
  { name: "Selin Y.", rating: 5, text: "Eşimle çift masajı için geldik, suit ve şampanya servisi muhteşemdi. Yeni geleneğimiz oldu, kesinlikle döneceğiz.", when: "3 hafta önce", service: "Çift Masajı" },
  { name: "Burak T.", rating: 5, text: "Bali masajı resmen başka bir dünya. Hijyen, ferah ortam, ilgili personel. Endonezya kokuları ile rahatlatıcı.", when: "1 ay önce", service: "Bali Masajı" },
  { name: "Cansu D.", rating: 5, text: "Karşılamadan veda anına kadar her detay düşünülmüş. Bursa'nın gerçek spa adresi burası.", when: "1 ay önce", service: "Klasik Masaj" },
  { name: "Onur P.", rating: 5, text: "Sıcak taş masajı sayesinde uzun süredir bu kadar derin uyumamıştım. Mekânın estetiği ve sessizliği büyüleyici.", when: "2 ay önce", service: "Sıcak Taş Masajı" },
  { name: "Zeynep A.", rating: 5, text: "İş stresinden bunalmıştım, klasik masaj sonrası kendimi yenilenmiş hissettim. Diamond Life'a teşekkürler.", when: "2 ay önce", service: "Klasik Masaj" },
  { name: "Hakan K.", rating: 5, text: "Ofis çalışanıyım, boyun ve sırt ağrım çok ciddiydi. Medikal masaj 8 seansta beni neredeyse iyileştirdi.", when: "3 ay önce", service: "Medikal Masaj" },
];

export const FAQS = [
  { q: "Randevu almak için ne kadar önceden başvurmalıyım?", a: "Tercih ettiğiniz saat ve hizmetin müsaitliği için en az 24 saat önceden randevu oluşturmanızı öneririz. Yoğun dönemlerde 2-3 gün önce planlamak idealdir. WhatsApp üzerinden 30 dakika içinde dönüş yapıyoruz." },
  { q: "Hangi ödeme yöntemleri kabul ediliyor?", a: "Nakit, kredi kartı ve banka havalesi ile ödeme alıyoruz. Tüm işlemler seans sonrasında resepsiyonda gerçekleştirilir." },
  { q: "İlk masaj deneyimim, hangi hizmeti seçmeliyim?", a: "İlk kez masaj alacak misafirlerimize Klasik Masaj veya Aromaterapi Masajı öneriyoruz. Konsültasyon sırasında size en uygun ritüel birlikte belirlenir." },
  { q: "Hijyen önlemleri nasıl uygulanıyor?", a: "Her seans öncesi özel odalar profesyonel ekipmanlarla tam dezenfekte edilir. Havlu ve örtüler tek kullanımlık veya yüksek ısıda yıkanmıştır. Uluslararası hijyen protokolleri uygulanır." },
  { q: "Çift masajı için özel bir oda var mı?", a: "Evet, iki kişilik özel suite'imizde eş zamanlı olarak iki terapist ile çift masajı uygulanır. Şampanya servisi dahildir." },
  { q: "Hediye çeki sunuyor musunuz?", a: "Tüm hizmetlerimiz için kişiye özel tasarlanmış hediye çekleri mevcuttur. Detaylar için bizimle iletişime geçiniz." },
];

export const GALLERY = [
  "https://images.unsplash.com/photo-1648612784714-322347f4fe84?auto=format&fit=crop&w=1200&q=85",
  "https://images.unsplash.com/photo-1601479604588-68d9e6d386b5?auto=format&fit=crop&w=1200&q=85",
  "https://images.unsplash.com/photo-1611441085337-56f4d0ea0ae2?auto=format&fit=crop&w=1200&q=85",
  "https://images.unsplash.com/photo-1643122966676-29e8597257f7?auto=format&fit=crop&w=1200&q=85",
  "https://images.unsplash.com/photo-1745327883508-b6cd32e5dde5?auto=format&fit=crop&w=1200&q=85",
  "https://images.unsplash.com/photo-1636714528228-f469eefb3eef?auto=format&fit=crop&w=1200&q=85",
  "https://images.unsplash.com/photo-1652720919938-81e2bf084a36?auto=format&fit=crop&w=1200&q=85",
  "https://images.unsplash.com/photo-1610402601271-5b4bd5b3eba4?auto=format&fit=crop&w=1200&q=85",
  "https://images.unsplash.com/photo-1636714507452-48716cfa1818?auto=format&fit=crop&w=1200&q=85",
  "https://images.unsplash.com/photo-1515377905703-c4788e51af15?auto=format&fit=crop&w=1200&q=85",
  "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?auto=format&fit=crop&w=1200&q=85",
  "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?auto=format&fit=crop&w=1200&q=85",
];
